import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["endYear", "endMonth"]

  connect() {
    // 初期化処理
  }

  toggleCurrentJob(event) {
    const isCurrent = event.target.checked

    if (this.hasEndYearTarget) {
      this.endYearTarget.disabled = isCurrent
    }
    if (this.hasEndMonthTarget) {
      this.endMonthTarget.disabled = isCurrent
    }

    if (isCurrent) {
      if (this.hasEndYearTarget) {
        this.endYearTarget.value = ""
      }
      if (this.hasEndMonthTarget) {
        this.endMonthTarget.value = ""
      }
    }
  }
}
